const validators = {
  email: (value) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  phone: (value) => value.replace(/[^0-9]/g, '').length === 10,
  url: (value) => /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/\S*)?$/i.test(value),
  text: (value) => value.trim().length > 0,
  select: (value, placeholder) => value && value !== placeholder,
  number: (value) => !isNaN(value) && value.toString().trim().length > 0,
  textarea: (value) => value.trim().length > 0,
  captcha: (value) => value !== null && value !== undefined && value !== ''
}

const handleBlur = (event, fieldId, fieldType, fieldLabel, required) => {
  if (!required) return

  const inputElement = event.target
  const inputValue = inputElement.value || inputElement.textContent || ''
  const grandparentElement = inputElement.parentNode.parentNode

  const isEmail = validators.email(inputValue)
  const isURL = validators.url(inputValue)

  if (fieldType === 'EMAIL' || fieldLabel === 'Email') {
    const inputElement = document.getElementById(fieldId)
    const parentDiv = inputElement.parentNode
    const existingWarning = parentDiv.querySelector('.warning-span')

    if (!isEmail && !existingWarning) {
      event.target.classList.add('emptyInput')
      const warning = document.createElement('span')
      warning.innerText = ' Please add a valid email address.'
      warning.className = 'warning-span'
      warning.setAttribute('data-cy', 'form-input-warning')
      parentDiv.appendChild(warning)
    } else if (isEmail && existingWarning) {
      event.target.classList.remove('emptyInput')
      parentDiv.removeChild(existingWarning)
    }
  } else if (fieldType === 'PHONE' || fieldLabel === 'mobile') {
    const inputElementPhone = document.getElementById(fieldId)
    const parentDivPhone = inputElement.parentNode
    const existingWarningPhone = parentDivPhone.querySelector('.warning-span-phone')
    const sanitizedInput = inputElementPhone.value.replace(/[^0-9]/g, '')

    if (sanitizedInput.length !== 10 && !existingWarningPhone) {
      inputElementPhone.classList.add('emptyInput')
      const warning = document.createElement('span')
      warning.innerText = 'Please add a valid ten-digit phone number.'
      warning.className = 'warning-span-phone'
      parentDivPhone.appendChild(warning)
    } else if (sanitizedInput.length === 10 && existingWarningPhone) {
      inputElementPhone.classList.remove('emptyInput')
      parentDivPhone.removeChild(existingWarningPhone)
    }
  } else if (fieldType === 'WEBSITE' || fieldLabel === 'Web Address' || fieldLabel === 'Website URL' || fieldLabel === 'LinkedIn URL') {
    const inputElement = document.getElementById(fieldId)
    const parentDiv = inputElement.parentNode
    const existingWarning = parentDiv.querySelector('.warning-span-web')

    if (!isURL && !existingWarning) {
      inputElement.classList.add('emptyInput')
      const warning = document.createElement('span')
      warning.innerText = 'Please add a valid web address.'
      warning.className = 'warning-span-web'
      parentDiv.appendChild(warning)
    } else if (isURL && existingWarning) {
      inputElement.classList.remove('emptyInput')
      parentDiv.removeChild(existingWarning)
    }
  } else if (fieldLabel === 'Social Address') {
    const inputElement = document.getElementById(fieldId)
    const parentDiv = inputElement.parentNode
    const existingWarning = parentDiv.querySelector('.warning-span-social')

    if (!isURL && !existingWarning) {
      const warning = document.createElement('span')
      warning.innerText = 'Please add a valid web address.'
      warning.className = 'warning-span-social'
      parentDiv.appendChild(warning)
    } else if (isURL && existingWarning) {
      inputElement.classList.remove('emptyInput')
      parentDiv.removeChild(existingWarning)
    }
  } else {
    const parentDiv = inputElement.parentNode
    const existingWarning = parentDiv.querySelector('.warning-span-required')
    const existingSelectWarning = grandparentElement.querySelector('.warning-span-select')

    // For dropdown selects with placeholder values
    const isSelectWithPlaceholder = ['My budget is...*', 'Select a Team*', '$'].includes(inputValue)

    if (isSelectWithPlaceholder) {
      // Clear classes properly
      parentDiv.classList.add('emptyInput')
      inputElement.classList.remove('emptyInput')
      grandparentElement.classList.remove('emptyInput')

      // Add warning if it doesn't exist
      if (!existingSelectWarning) {
        const warning = document.createElement('span')
        warning.innerText = 'This field is required.'
        warning.className = 'warning-span-select'
        warning.setAttribute('data-cy', 'select-error')
        grandparentElement.appendChild(warning)
      }
    } else if (!inputValue.trim()) {
      // For empty text inputs
      inputElement.classList.add('emptyInput')
      parentDiv.classList.remove('emptyInput')
      grandparentElement.classList.remove('emptyInput')

      if (!existingWarning) {
        const warning = document.createElement('span')
        warning.innerText = 'This field is required.'
        warning.className = 'warning-span-required'
        warning.setAttribute('data-cy', 'form-input-warning')
        parentDiv.appendChild(warning)
      }
    } else {
      // For valid inputs, clean up all error classes and messages
      inputElement.classList.remove('emptyInput')
      parentDiv.classList.remove('emptyInput')
      grandparentElement.classList.remove('emptyInput')

      // Clean up any warning messages
      if (existingWarning) {
        parentDiv.removeChild(existingWarning)
      }

      if (existingSelectWarning) {
        grandparentElement.removeChild(existingSelectWarning)
      }
    }
  }
}

export const validateOnSubmit = (formFields, fieldValues) => {
  let isValid = true

  // Check CAPTCHA first regardless of required status
  const captchaField = formFields.nodes.find((field) => field.type === 'CAPTCHA')
  if (captchaField) {
    const captchaValue = fieldValues[captchaField.databaseId]
    if (!captchaValue) {
      const captchaDiv = document.querySelector('.captcha')
      if (captchaDiv && !captchaDiv.querySelector('.warning-span-captcha')) {
        const warning = document.createElement('span')
        warning.innerText = 'Please complete the CAPTCHA verification.'
        warning.className = 'warning-span-captcha'
        warning.setAttribute('data-cy', 'captcha-error')
        captchaDiv.appendChild(warning)
      }
      isValid = false
    }
  }

  // Then validate required fields
  formFields.nodes.forEach((field) => {
    if (!field.isRequired || field.type === 'CAPTCHA') return

    const value = fieldValues[field.databaseId]
    const inputElement = document.getElementById(field.databaseId)

    if (inputElement) {
      handleBlur({ target: inputElement }, field.databaseId, field.type, field.label, field.isRequired)
    }

    if (!value) {
      isValid = false
      return
    }

    if (field.type === 'EMAIL' || field.label === 'Email') {
      if (!validators.email(value)) isValid = false
    } else if (field.type === 'PHONE' || field.label === 'mobile') {
      if (!validators.phone(value)) isValid = false
    } else if (
      field.type === 'WEBSITE' ||
      field.label === 'Web Address' ||
      field.label === 'Website URL' ||
      field.label === 'LinkedIn URL'
    ) {
      if (!validators.url(value)) isValid = false
    } else if (field.label === 'Social Address') {
      if (!validators.url(value)) isValid = false
    } else {
      if (!validators.text(value)) isValid = false
    }
  })

  return isValid
}
